<div class="flex align-items-center justify-content-between">
  <div class="flex">
    <p-dropdown class="mr-1" [options]="bytesOptions" [(ngModel)]="byte" optionLabel="name" optionValue="value"></p-dropdown>
    <div *ngFor="let value of bitValues; let i = index" class="flex align-items-center">
      <p-button *ngIf="isInByte(i)" class="mr-1"
        [label]="value ? '1' : '0'"
        [styleClass]="'px-3 ' + (value ? 'p-button-primary' : 'p-button-secondary')"
        [style.height]="'32px'"
        (onClick)="switchBit(i);"
      ></p-button>
    </div>
  </div>
  <div class="ml-3" *ngIf="valueDecimal >= 16"><b>0x{{valueDecimal?.toString(16).toUpperCase()}}</b> ({{valueDecimal}})</div>
  <div class="ml-3" *ngIf="valueDecimal < 16"><b>0x0{{valueDecimal?.toString(16).toUpperCase()}}</b> ({{valueDecimal}})</div>
</div>
